import { BlackListQryType } from './components/black-list-banner/types';
/**
 * 登录类型
 */
export enum LoginType {
  User = 'user',
  Doctor = 'doctor',
}

export enum Gender {
  male = 1,
  female = 2,
}

export enum ApiState {
  ready = 'ready',
  fetching = 'fetching',
  success = 'success',
  error = 'error',
}

export enum IdentityCardType {
  idCard = 1, // 身份证
  hkCountryCard = 2, // 香港居民回乡证
  moCountryCard = 3, // 澳门居民回乡证
  twCountryCard = 4, // 台湾居民回乡证 
}

export enum NcovDataType {
  // 本港确诊新型冠状病毒的个案详情
  geAn = 1,
  // 过去14天内曾有确诊新型冠状病毒感染个案在出现病征期间逗留过的大厦名单
  buildingList = 2,
  // 本港严重新型传染性病原体呼吸系统病的最新情况
  cases = 3,
  // 过去14天内曾有确诊新型冠状病毒感染个案在出现病征期间乘搭过的航班/火车/船名单
  flightsTrainsList = 4,
  // 接受家居检疫人士所居住大厦的名单
  buildingListHomeConfinees = 5,
  // hk_confirmed_cases_epi_curve
  hk_confirmed_cases_epi_curve = 6,
  // 全球疫情统计总数据
  global_total_cases = 7,
  // 全球各地区最新数据
  global_region_cases = 8,
}

export enum ChartType {
  ByNewCase = 1, // 新增个案趋势
  ByTypeCase = 2, // 确诊个案分类
  ByRATNewCase = 3, // 确诊个案分类
  ByTotalNewCase = 4, // 确诊个案分类
}

/** 营销banner配置数据 */
export interface PromBannerData {
  /** banner链接-中文 */
  imageSrcCn: string;
  /** banner链接-英文 */
  imageSrcEn?: string;
  /** banner点击跳转链接 */
  link: string;
  /** banner点击埋点字段 */
  bannerClick: string;
  /** banner曝光埋点字段 */
  bannerBrow?: string;
  /** 用户包黑白名单id */
  blackListAckListId?: string;
  /** 黑白名单查询类型 */
  blackListQryType?: BlackListQryType;
}
